import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Header } from "../../../components/header";
import { CardHeader } from "../../../components/cards";
import { SendIcon } from "../../../components/icons";
import {
  OrderStatus,
  PaymentStatus,
  DeliveryStatus,
  DeliveryFeeOrigin,
} from "../../../__generated__/globalTypes";
import { useCreateOrder } from "../hooks";
import { OrderForm } from "../components";

export const CreateOrder: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const customerId = searchParams.get("customerId");

  const { form, submit, loading } = useCreateOrder({
    defaultValues: {
      customerId: customerId ? +customerId : undefined,
      status: OrderStatus.Draft,
      paymentStatus: PaymentStatus.Unpaid,
      deliveryStatus: DeliveryStatus.ToPlan,
      deliveryFeeOrigin: DeliveryFeeOrigin.Auto,
    },
    onCompleted: (id) => {
      toast.success("La commande a été créée avec succès");
      if (id) {
        navigate(`/order/${id}`);
      }
    },
  });

  return (
    <>
      <Header
        title="Commande"
        subtitle="Créer une nouvelle commande"
        buttons={[
          {
            actionText: "Annuler",
            bgColor: "indigo",
            textColor: "white",
            link: `/orders`,
            icon: <SendIcon />,
          },
        ]}
      />
      <div className="main-container">
        <div className="card">
          <CardHeader title="Nouvelle commande" />
          <OrderForm loading={loading} submit={submit} form={form} />
        </div>
      </div>
    </>
  );
};
